import axios from "axios";

const API_URL = process.env.REACT_APP_API_ENDPOINT;

const delegationApi = {
  // STEP 0 - CREATE
  async createDelegation(slug, delegation) {
    const body = {
      email: delegation.email,
      personType: delegation.personType,
      telephone: delegation.uid
        ? `${delegation.telephone}`
        : `+${delegation.telephone}`,
      uid: delegation.uid || null,
    };
    const response = await axios.post(
      `${API_URL}solicitation/${slug}/delegation/create`,
      body,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      },
    );
    return response;
  },

  // STEP 1 - SET DOC BUILDER
  async setDocBuilder(slug, uid, uuid) {
    const body = { docBuilderSubmissionId: uuid };
    return axios.post(
      `${API_URL}solicitation/${slug}/delegation/${uid}/set-docbuilder`,
      body,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      },
    );
  },

  // STEP 2 - VALIDATE DOC
  async validateSubmission(slug, uid) {
    return axios.post(
      `${API_URL}solicitation/${slug}/delegation/${uid}/confirm-docbuilder`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      },
    );
  },

  // UPLOAD DOCUMENTS
  async uploadIdentityDocumentFront(slug, uid, files) {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append("identityDocumentFront", file);
    });

    return axios.post(
      `${API_URL}solicitation/${slug}/delegation/${uid}/upload-identity-document-front`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
      },
    );
  },

  async uploadIdentityDocumentRear(slug, uid, files) {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append("identityDocumentRear", file);
    });

    return axios.post(
      `${API_URL}solicitation/${slug}/delegation/${uid}/upload-identity-document-rear`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
      },
    );
  },

  async uploadIdentityDocumentUnique(slug, uid, files) {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append("identityDocumentUnique", file);
    });

    return axios.post(
      `${API_URL}solicitation/${slug}/delegation/${uid}/upload-identity-document-unique`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
      },
    );
  },

  async confirmIdentityDocument(slug, uid, typeDocument) {
    const formData = new FormData();
    formData.append("identityDocumentType", typeDocument);
    return axios.post(
      `${API_URL}solicitation/${slug}/delegation/${uid}/confirm-identity-document`,
      formData,
      { headers: { Accept: "application/json" } },
    );
  },

  async deleteDocument(slug, uid, documentType) {
    const formData = new FormData();
    formData.append("documentType", documentType);
    return axios.post(
      `${API_URL}solicitation/${slug}/delegation/${uid}/delete-document`,
      formData,
      { headers: { Accept: "application/json" } },
    );
  },

  async setDocumentType(slug, uid, typeDocument) {
    const formData = new FormData();
    formData.append("identityDocumentType", typeDocument);
    return axios.post(
      `${API_URL}solicitation/${slug}/delegation/${uid}/set-identity-document-type`,
      formData,
      { headers: { Accept: "application/json" } },
    );
  },

  // MEDIA DOWNLOAD / PREVIEW
  async getMedia(slug, uid, documentString) {
    const pathParts = documentString.split(/[/\\]/);
    const documentPath = pathParts[pathParts.length - 1];

    return axios.get(
      `${API_URL}solicitation/${slug}/delegation/${uid}/media/${documentPath}`,
      { responseType: "blob", headers: { Accept: "application/pdf" } },
    );
  },

  // SIGNATURE
  async setSignatureMethod(slug, uid, signatureMethod) {
    const body = { signatureMethod };
    return axios.post(
      `${API_URL}solicitation/${slug}/delegation/${uid}/set-signature-method`,
      body,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      },
    );
  },

  async uploadSignedDocument(slug, uid, files) {
    const formData = new FormData();
    files.forEach((f) => formData.append("signedDocument", f));
    return axios.post(
      `${API_URL}solicitation/${slug}/delegation/${uid}/upload-signed-document`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
      },
    );
  },

  async confirmSignedDocument(slug, uid, file) {
    const formData = new FormData();
    formData.append("signedDocument", file);
    return axios.post(
      `${API_URL}solicitation/${slug}/delegation/${uid}/confirm-signed-document`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
      },
    );
  },

  async startSignatureProcess(slug, uid, formDataYousign) {
    const body = {
      firstname: formDataYousign.name,
      lastname: formDataYousign.lastname,
      telephone: formDataYousign.mobile,
      email: formDataYousign.email,
    };
    return axios.post(
      `${API_URL}solicitation/${slug}/delegation/${uid}/start-signature-process`,
      body,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      },
    );
  },

  async endSignatureProcess(slug, uid) {
    return axios.post(
      `${API_URL}solicitation/${slug}/delegation/${uid}/end-signature-process`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      },
    );
  },

  async downloadDelegation(slug, uid, filePath) {
    const pathParts = filePath.split(/[/\\]/);
    const documentPath = pathParts[pathParts.length - 1];
    return axios.get(
      `${API_URL}solicitation/${slug}/delegation/${uid}/media/${documentPath}`,
      { responseType: "blob", headers: { Accept: "application/pdf" } },
    );
  },
};

export default delegationApi;
